export default "__VITE_ASSET__CpRgCC7b__"